module.exports = __webpack_public_path__ + "img/logo.73d7b955.png";